import { TIMEZONES } from "shared/constants/time";

const getTimezone = () => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const findTZ = TIMEZONES.find(tz => tz.value === userTimezone);
  return findTZ ? findTZ.value : "America/New_York";
};

export default getTimezone;
